module.exports = __webpack_public_path__ + "media/images/new_home/4-brittani-harris-5baa48726cbe72359bbceff45044091d.png";